<template>
  <IdentifyDblTop next-page-id="en008" previous-page-id="en006">
    <template #wizard>
      <WizardGroup class="_mb-sm-35 _mb-md-50">
        <MainWizard :active-index="2" type="en2"></MainWizard>
        <SubWizard :active-index="0" type="upload"></SubWizard>
      </WizardGroup>
    </template>
    <template #message>
      <CardBox class="-margin-md">
        <CardHeader class="upload-header">
          <div class="flex">
            <h2 class="heading _mr-10 _mr-md-20 upload-heading">
              ご本人さま確認書類のご提出
            </h2>
            <span class="upload-label">わずか3ステップ</span>
          </div>
        </CardHeader>
        <p class="upload-txt">
          書類を選択し、撮影、アップロードするだけでお申し込みは完了します。
        </p>
        <CardBody class="upload-body">
          <ListGroup class="-normal">
            <ListItem class="-normal"
              >お申し込みにあたり、ご本人さま確認をさせていただくため、現住所が記載されたご本人さま確認書類を2点選択し、以下の手順に従ってアップロードしてください。</ListItem
            >
            <ListItem class="-normal"
              >お手続きには1週間程度、お時間がかかります。</ListItem
            >
            <ListItem class="-normal"
              >ご融資可能なお客さまには、ご契約に必要な「確認コード」を記載したハガキをご登録住所あてに「転送不要」の簡易書留または、本人限定受取郵便にてお送りさせていただきますので、必ずお受取りください。なお、郵便には保管期限がございますので、ご注意ください。</ListItem
            >
            <ListItem class="-normal"
              >口座のご登録はご契約後に会員さま専用サイトにてお手続きください。</ListItem
            >
            <ListItem class="-normal"
              >画像データが不鮮明などの理由で不備となった場合は、再度アップロードをお願いする場合があります。その場合は、お手続きにお時間がかかる場合がありますのであらかじめご了承ください。</ListItem
            >
          </ListGroup>
        </CardBody>
      </CardBox>
    </template>
    <template #message2>
      <div class="_mb-30">
        <div>
          <small
            >※書類を2点ご用意いただけない場合、または、上記以外の書類をご希望の場合は、コールセンターへお問い合わせください。</small
          >
        </div>
        <div class="_mt-10">
          <BtnText
            router-name="sv036"
            class="-next"
            hash="#section_01"
            target="_blank"
            >お問い合わせはこちら</BtnText
          >
        </div>
      </div>
    </template>
  </IdentifyDblTop>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IdentifyDblTop from "@/components/fileupload/IdentifyDblTop";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import SubWizard from "@/components/wizard/SubWizard";
import CardBody from "@/components/card/CardBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import BtnText from "@/components/button/BtnText";

export default {
  name: "En007",
  components: {
    BtnText,
    CardHeader,
    CardBox,
    ListItem,
    ListGroup,
    CardBody,
    SubWizard,
    MainWizard,
    WizardGroup,
    IdentifyDblTop,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,本人確認書類",
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.card-header.upload-header {
  padding-bottom: 10px;
  @include mq-down(md) {
    padding-left: 13px;
    padding-right: 13px;
  }
}

.card-body.upload-body {
  padding-top: 0;
}

.upload-heading {
  white-space: nowrap;
  @include mq-down(md) {
    margin-bottom: 5px;
  }
}

.upload-label {
  display: block;
  background-color: $danger;
  color: $white;
  font-weight: normal;
  text-align: center;
  border-radius: 5px;
  @include mq-down(md) {
    width: 101px;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 5px;
  }
  @include mq-up(md) {
    width: 132px;
    font-size: 16px;
    line-height: 28px;
  }
}

.upload-txt {
  color: $danger;
  @include mq-down(md) {
    padding-left: 13px;
    padding-right: 13px;
    margin-bottom: 5px;
  }
  @include mq-up(md) {
    padding-left: 25px;
    padding-right: 25px;
    margin-bottom: 5px;
  }
}
</style>
